import { useMemo } from 'react';
import { Tbody } from '@chakra-ui/react';
import { Table } from '@tanstack/react-table';
import SkeletonTable from './SkeletonTable';
import NoDataBody from './NoDataBody';
import DraggableRow, { DefaultTableData } from './DraggableRow';

interface Props<TData> {
  table: Table<TData>;
  isLoading: boolean;
  data: TData[];
  size?: number;
  draggable: boolean;
}

const TableBody = <TData extends DefaultTableData>({
  table,
  isLoading,
  data,
  size,
  draggable
}: Props<TData>) => {
  const columns = useMemo(() => table.getAllColumns(), [data]);
  const rows = useMemo(() => table.getRowModel().rows, [data]);

  if (isLoading) return <SkeletonTable<TData> table={table} size={size} />;
  if (!rows.length) return <NoDataBody length={columns.length} />

  return (
    <Tbody>
      {rows.map((row) =>
        <DraggableRow
          key={row.id}
          draggable={draggable}
          row={row}
        />
      )}
    </Tbody>
  );
};

export default TableBody;
